import { render, staticRenderFns } from "./DownloadExamples.vue?vue&type=template&id=67947c64&scoped=true"
import script from "./DownloadExamples.vue?vue&type=script&lang=js"
export * from "./DownloadExamples.vue?vue&type=script&lang=js"
import style0 from "./DownloadExamples.vue?vue&type=style&index=0&id=67947c64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67947c64",
  null
  
)

export default component.exports